import {createContext} from 'react';

interface SelectedCountryContextType {
  efdbData: any;
  selectedCountry: string;
  setSelectedCountry: React.Dispatch<React.SetStateAction<string>>;
  facilityId: string;
  selectedYear: string;
}

const SelectedCountryContext = createContext<SelectedCountryContextType>({
  efdbData: {},
  selectedCountry: '',
  setSelectedCountry: () => {},
  facilityId: '',
  selectedYear: ''
});

export default SelectedCountryContext;
